module.exports = __webpack_public_path__ + "img/1中文.8ccce2b9.png";